/**
 * Validates email form element
 * @param  {string}   value Value of email input element
 * @return {boolean}  Boolean of valid value
 */
export function validateEmail(value) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  );
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/validationHelpers.js